/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReminderOverview } from './ReminderOverview';
import {
    ReminderOverviewFromJSON,
    ReminderOverviewFromJSONTyped,
    ReminderOverviewToJSON,
    ReminderOverviewToJSONTyped,
} from './ReminderOverview';

/**
 * 
 * @export
 * @interface ReminderOverviewResponse
 */
export interface ReminderOverviewResponse {
    /**
     * 
     */
    data: ReminderOverview;
}

/**
 * Check if a given object implements the ReminderOverviewResponse interface.
 */
export function instanceOfReminderOverviewResponse(value: object): value is ReminderOverviewResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ReminderOverviewResponseFromJSON(json: any): ReminderOverviewResponse {
    return ReminderOverviewResponseFromJSONTyped(json, false);
}

export function ReminderOverviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReminderOverviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ReminderOverviewFromJSON(json['data']),
    };
}

export function ReminderOverviewResponseToJSON(json: any): ReminderOverviewResponse {
    return ReminderOverviewResponseToJSONTyped(json, false);
}

export function ReminderOverviewResponseToJSONTyped(value?: ReminderOverviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ReminderOverviewToJSON(value['data']),
    };
}

